<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Prevención De Lavado de Activo
        </v-card-title>
        <v-container fluid grid-list-sm>
            <v-row dense>
                <v-col cols="12" sm="4" v-if="_.size(listGeneral.listaContratantes) > 1">
                    <v-autocomplete label="Contratante *" color="textbox" v-model="objBusqueda.idContratante"
                        :items="listGeneral.listaContratantes" item-value="idContratante" item-text="contratante"
                        @change="onCambiaContratante" outlined dense :disabled="disabled"/>
                </v-col>
                <v-col cols="12" sm="4" v-else>
                    <v-text-field label="Contratante *" color="textbox"
                        :value="_.get(listGeneral,['listaContratantes','0','contratante'],null)" readonly outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Póliza " color="textbox" v-model="objBusqueda.idPoliza"
                        :items="listGeneral.listaPolizas" item-value="id_poliza" item-text="poliza"
                        @change="onListarDetalleContratante" outlined dense :disabled="disabled"/>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Estado " color="textbox" v-model="objBusqueda.idEstado" :items="listGeneral.listaEstados"
                        item-text="nombre_estado" item-value="id_estado" outlined dense @change="onListarDetalleContratante"
                        :disabled="disabled">
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row dense v-if="!imprimir && !bloqueado">
                <v-col cols="12" sm="12">
                    <v-stepper v-model="e6" vertical class="removeBorder">
                        <v-stepper-step :complete="e6 > 1" step="1" :rules="validacionSteps.datosContratante">Datos del Contratante</v-stepper-step>

                            <v-stepper-content step="1">
                                <StepperDatoGeneralComponent :cargar="cargar" 
                                                             :objForm="objForm.objDatosGenerales"
                                                             :listGeneral="listGeneral" 
                                                             :parametros="parametros" 
                                />
                            </v-stepper-content>

                        <v-stepper-step :complete="e6 > 2" step="2" :rules="validacionSteps.datosRepresentante">Datos del Representante</v-stepper-step>

                            <v-stepper-content step="2">
                                <StepperDatoRepresentanteComponent :cargar="e6 == 2 ? true : false" 
                                                                   :objForm="objForm.objDatosRepre"
                                                                   :listGeneral="listGeneral" 
                                                                   :parametros="parametros" 
                                />

                            </v-stepper-content>

                        <v-stepper-step :complete="e6 > 3" step="3" :rules="validacionSteps.datosArchivos"> Archivos
                            <small v-show="validacionSteps.mostrarMensajeErrorArchi">Debe subir todos los archivos solicitados.</small>
                        </v-stepper-step>

                            <v-stepper-content step="3">
                                <StepperDocumentoComponent :cargar="e6 == 3 ? true : false" 
                                                           :objForm="objForm.objArchivos"
                                                           :parametros="parametros"
                                />
                            </v-stepper-content>

                        <v-stepper-step :complete="e6 > 4" step="4" :rules="validacionSteps.datosFinancieros"> Referencias Financieras
                            <small v-show="validacionSteps.mostrarMensajeErrorFina">Debe ingresar al menos un registro.</small>
                        </v-stepper-step>

                            <v-stepper-content step="4">
                                <StepperReferenciaFinancieraComponent :cargar="e6 == 4 ? true : false" 
                                                                      :listGeneral="listGeneral"
                                                                      :objForm="objForm.objRefBan" 
                                                                      :parametros="parametros"
                                />
                            </v-stepper-content>
                        
                    </v-stepper>
                </v-col>
            </v-row>

            <v-row v-else-if="imprimir">
                <v-col cols="12" sm="12">
                    <v-container fluid grid-list-md>
                        <v-row dense align="center" justify="center">
                            <v-col cols="12" sm="12" class="text-xs-center">
                                <v-tooltip top color="primary" dark>
                                    <template v-slot:activator="{ on }">
                                        <img :src="iconFile.base64" alt="File" v-on="on" @click="loadFile">
                                    </template>
                                    <span>Ver PDF</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <modalPdfComponent :mostrar="objPdf.mostrar" :base64="objPdf.base64" :titulo="objPdf.titulo"/>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        name: 'PLAContratanteView',
        components:{
           StepperDatoGeneralComponent: () => import('@/components/prevencionLavadoActivo/contratante/StepperDatoGeneralComponent.vue'),
           StepperDatoRepresentanteComponent: () => import('@/components/prevencionLavadoActivo/contratante/StepperDatoRepresentanteComponent.vue'),
           StepperDocumentoComponent: () => import('@/components/prevencionLavadoActivo/contratante/StepperDocumentoComponent.vue'),
           StepperReferenciaFinancieraComponent: () => import('@/components/prevencionLavadoActivo/contratante/StepperReferenciaFinancieraComponent.vue'),
           modalPdfComponent: () => import('@/components/utilites/modalComponent.vue')
        },
        data: () => ({
            objPdf:{ mostrar: false, base64: '',titulo: ''},
            iconFile:{ base64: ''},
            validacionSteps: {
                datosContratante  : [ () => true ],
                datosRepresentante: [ () => true ],
                datosArchivos     : [ () => true ],
                mostrarMensajeErrorArchi: false,
                datosFinancieros  : [ () => true ],
                mostrarMensajeErrorFina: false
            },
            e6:1,
            cargar: false,
            radioGroup: false,
            listGeneral: {},
            parametros:{},
            imprimir: false,
            bloqueado: true,
            objBusqueda:{},
            estados: ["contratante_0","poliza_0"],
            objForm: {
                objDatosGenerales : {},
                objDatosRepre     : {},
                objArchivos       : {},
                objRefBan         : {}
            }
        }),
        computed:{
            disabled(){
                return this.e6 > 1 ? true : false;
            }
        },
        watch:{
            imprimir(val){
                this.iconFile.base64 = '';
                if(val){
                    var error = 'E';
                    var objeto = {'path': this.objForm.objDatosGenerales.path, 'mini' : true};

                    axios.post(`${BASE_URI}administrador/repository-file/listar`,objeto)
                         .then((respuesta) => {
                            if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); } 
                                this.iconFile.base64 = JSON.parse(JSON.stringify(r.data.data));
                        })
                        .catch((e)=>{
                            mensajesAlerta(e,error);
                        })
                }
            },
            e6(val){
                switch (val) {
                    case 2:
                        var id = _.get(this.objForm.objDatosRepre,'idTipoDocumento',undefined)
                        if(_.isUndefined(id)){
                            var o = _.merge({},
                                            {"idEstado": _.toString(this.parametros.idEstadoDefault)},
                                            this.objForm.objDatosRepre,
                                            _.pick(this.objForm.objDatosGenerales,['idFormulario','idContratante','idPoliza'])
                                            );
                            
                            this.$set(this.objForm,'objDatosRepre',o);
                        }
                        break;

                    case 3:
                        var o = _.merge({},
                                        {"idEstado": _.toString(this.parametros.idEstadoDefault)},
                                        this.objForm.objArchivos,
                                        _.pick(this.objForm.objDatosGenerales,['idFormulario','idContratante'])
                                        );
                        
                        this.$set(this.objForm,'objArchivos',o);
                        break;
                    case 4:
                        var o = _.merge({},
                                        {"idEstado": _.toString(this.parametros.idEstadoDefault),
                                         "idTipoCuenta": '',"nroCuenta": '',"idInstitucionFinanciera": ''},
                                         this.objForm.objRefBan,
                                         _.pick(this.objForm.objDatosGenerales,['idFormulario','idContratante','idPoliza'])
                                        );

                        this.$set(this.objForm,'objRefBan',o);
                        break;
                }
            }
        },
        created(){
            var error = 'E';
            
            axios.post(`${BASE_URI}administrador/prevension-lavado-activo/contratante/cargaGeneral`)
                 .then((r)=>{
                    if (_.get(r, ['data','existeError'], true)) throw mensajeEstandar.errorPeticion;
                    if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); } 
                        this.$set(this,'listGeneral',r.data.data.listas);
                        this.$set(this,'parametros',r.data.data.parametros);
                        this.objBusqueda.idEstado = _.toString(this.parametros.idEstadoDefault);

                    return axios.post(`${BASE_URI}administrador/contratante/listar`,{'opcion' : 'LC'})
                 })
                 .then((r)=>{
                    if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                    if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); } 
                        this.listGeneral.listaContratantes = r.data.data.detalle;
                        this.$set(this.objBusqueda,'idContratante',this.listGeneral.listaContratantes[0].idContratante);    

                    return this.onListarPoliza('L');
                })
                 .then((r)=>{
                    // onListarPoliza ya mostró el mensaje del servicio, no se continúa
                    if (_.get(r, 'handled', false)) throw r;
                    if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                    if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); } 
                        this.$set(this.objForm,'objDatosGenerales',this.listGeneral.listaContratantes[0]);

                    return this.onListarDetalleContratante('L');
                })
                 .catch((e)=>{
                     if (_.get(e, 'handled', false)) return;
                     mensajesAlerta(e,error);
                 });
        },
        methods:{
            onListarPoliza(e){
                if(!_.isUndefined(e)){
                    var error = 'E';
                    var estado = (_.split(_.find(this.estados, (o) => {  return o.search('pol') >= 0 }), '_'))[1]; 
                    var objeto = {
                                    'opcion'        : 'LISTAR', 
                                    'idContratante' : _.get(this.objBusqueda,'idContratante',null),
                                    'idEstado'      : _.get(this.objBusqueda,'idEstado',null),
                                };

                    this.$set(this.objForm,'objDatosGenerales',{});
                    this.$set(this.objBusqueda,'idPoliza',undefined);
                    this.$set(this.listGeneral,'listaPolizas',[]);
                    this.bloqueado = true;
                    this.imprimir = false;

                    return axios.post(`${BASE_URI}administrador/poliza/listar`, objeto)
                                .then((r) => {
                                    if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                    if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); } 

                                        this.listGeneral.listaPolizas = r.data.data;
                                        if(_.isUndefined(this.objBusqueda.idPoliza))
                                            this.$set(this.objBusqueda,'idPoliza',this.listGeneral.listaPolizas[0].id_poliza);
                                        return r;
                                })
                                .catch((e)=>{
                                    mensajesAlerta(e,error);
                                    return { handled: true };
                                });
                }
            },
            onCambiaContratante(e){
                if(!_.isUndefined(e)){
                    return this.onListarPoliza('L')
                               .then((r)=>{
                                    if(!_.get(r,'handled',false))
                                        return this.onListarDetalleContratante('L');
                               });
                }
            },
            onListarDetalleContratante(event){
                if(!_.isUndefined(event)){
                    var error = 'E';
                    var objeto = {
                                    'opcion' : 'L',
                                    'idContratante':this.objBusqueda.idContratante
                                };  
                    this.$set(this.objForm,'objDatosGenerales',{});
                    this.bloqueado = true;
                    this.imprimir = false;

                    return axios.post(`${BASE_URI}administrador/contratante/listar`,objeto)
                                .then((r)=>{
                                    if (_.get(r, ['data','existeError'], true)) throw mensajeEstandar.errorPeticion;
                                    if (_.size(_.get(r, ['data','data'], [])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); } 
                                        this.$set(this.objForm,'objDatosGenerales',r.data.data.detalle[0]);

                                        var objeto = {
                                            'opcion'        : 'LISTAR_DETALLE_INGRESOS',
                                            'idContratante' : _.get(this.objBusqueda,'idContratante',null),
                                            'idPoliza'      : _.get(this.objBusqueda,'idPoliza',null),
                                            'idEstado'      : _.get(this.objBusqueda,'idEstado',null)
                                        }
                            
                                    return axios.post(`${BASE_URI}administrador/prevension-lavado-activo/contratante/listar`,objeto);
                                })
                                .then((r)=>{
                                    if (_.get(r, ['data','existeError'], true)) throw mensajeEstandar.errorPeticion;
                                    if (_.size(_.get(r, ['data','data'], [])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); } 
                                        this.$set(this.objForm.objDatosGenerales,'idPoliza',this.objBusqueda.idPoliza);
                                        this.$set(this.objForm.objDatosGenerales,'idFormulario',r.data.data[0].idFormulario);
                                        this.$set(this.objForm.objDatosGenerales,'actEconomica', r.data.data[0].actEconomica);
                                        this.$set(this.objForm.objDatosGenerales,'idEstadoProcesado',r.data.data[0].idEstadoProcesado);
                                        this.imprimir = _.toNumber(this.objForm.objDatosGenerales.idEstadoProcesado) == this.parametros.idEstadoDefault ? true : false;
                                        this.bloqueado = false;
                                })
                                .catch((e)=>{
                                    // sin formulario activo: se limpia el formulario y no se permite continuar
                                    this.$set(this.objForm,'objDatosGenerales',{});
                                    this.bloqueado = true;
                                    mensajesAlerta(e,error);
                                    return e;
                                });
                }
            },
            next(nameKey,data,n=true){
                if(_.isArray(data))
                    _.set(this.listGeneral,nameKey,data);
                else
                    _.set(this.objForm,nameKey,_.merge({},_.get(this.objForm,nameKey,{}),data));

                if(n)
                    ++this.e6;
            },
            previous(nameKey,data,n=true){
                if(_.isArray(data))
                    _.set(this.listGeneral,nameKey,data);
                else
                    _.set(this.objForm,nameKey,_.merge({},_.get(this.objForm,nameKey,{}),data));

                if(n)
                    --this.e6;
            },
            loadFile(event){
                if(!_.isUndefined(event)){
                    var error = 'E';

                    axios.post(`${BASE_URI}administrador/repository-file/listar`,{'path': this.objForm.objDatosGen.path})
                        .then((r) => {
                            if (_.get(r, ['data','existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data','data'], [])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); } 
                                this.objPdf.base64 = JSON.parse(JSON.stringify(respuesta.data.data));
                                this.objPdf.titulo = 'Formulario de Prevención de Lavado de Activos';
                                this.objPdf.mostrar = true;
                        })
                        .catch((e) => {
                            mensajesAlerta(e,error);
                        });
                }
            },
            setValidateStep(data){
                this.$set(this,'validacionSteps',_.merge({},_.get(this,'validacionSteps',{}),data));
            },
            insertarActualizar(){
                this.objForm.objDatosGenerales.idEstado = _.get(this.objForm.objDatosGenerales,'idEstado',this.parametros.idEstadoDefault);
                var kOG = ['idFormulario','idContratante','actEconomica','idPoliza','idEstadoProcesado','idEstado'];
                var error = 'E';

                var listArchivo = [];
                var l = _.filter(_.cloneDeep(this.objForm.objArchivos),(v)=>{ return _.isObject(v) && _.size(_.get(v,'base','')) > 0; });

                    _.map(l,(v)=>{
                        listArchivo.push({
                            idSecDocumento: _.get(v,'idSecDocumento',null),
                            idDocumento: _.get(v,'id',null),
                            idFormulario: _.get(this.objForm.objDatosGenerales,'idFormulario',null),
                            base64File: _.get(v,'base',null),
                            nameFile: _.get(v,'nameFile',null),
                            idEstado: this.parametros.idEstadoDefault
                        });
                    });

                var o = {
                    'opcion': _.isUndefined(this.objForm.objDatosGenerales.idFormulario) || _.isNull(this.objForm.objDatosGenerales.idFormulario) ? 'I' : 'U',
                    'contratante': true,
                    'objDetalleIng': _.merge({},_.pick(this.objForm.objDatosGenerales,kOG)),
                    'objRepresentante': this.objForm.objDatosRepre,
                    'objArchivos': listArchivo,
                    'listaReferenciaFinanciera': this.listGeneral.listaReferenciaFinanciera
                }

                return axios.post(`${BASE_URI}administrador/prevension-lavado-activo/contratante/insertOrUpdate`,o)
                            .then((r)=>{
                                if (_.get(r, ['data','existeError'], true)) throw mensajeEstandar.errorPeticion;
                                if (_.size(_.get(r, ['data','data'], [])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); } 
                                    mensajeAlertaTiempo(r.data.mensaje,'S');
                                    setTimeout(() => { window.location.reload(); },1600);  
                                    return true;
                            })
                            .catch((e)=>{
                                mensajesAlerta(e,error);
                                return false;
                            });
            },
            cerrarModalPdf(){
                this.objPdf.mostrar =  false;
                this.objPdf.base64 = '';
            }
        },
        provide(){
            return{
                next                : this.next,
                previous            : this.previous,
                setValidateStep     : this.setValidateStep,
                insertarActualizar  : this.insertarActualizar,
                cerrarModalPdf      : this.cerrarModalPdf
            }
        }
    }
</script>
<style type="text/css">
    .removeBorder {
        box-shadow: none !important;
    } 
</style>